import { Box, Grid, MultiSelect } from "@mantine/core"
import { DatePicker } from "@mantine/dates"
import { IconCalendarUser } from "@tabler/icons-react";
import 'dayjs/locale/es';
import type { IFiltrosAgendaVistaProps } from "../interfaces";
import dayjs from "dayjs";

const FiltrosAgendaVista: React.FunctionComponent<IFiltrosAgendaVistaProps> = ({ listaTecnicos, filtro, manejarCambioFiltroAgenda }) => {
    return (
        <Box>
            <Grid gutter="sm" >
                <Grid.Col span={{ base: 12, md: 12 }}>
                    <MultiSelect
                        label="Técnico"
                        placeholder="Técnico"
                        name="Tecnico"
                        data={listaTecnicos.map(c => ({
                            value: c.Id.toString(),
                            label: c.NombreCompleto,
                        }))}
                        comboboxProps={{ zIndex: 1000000 }}
                        value={filtro.Tecnicos.map(t => t.Id.toString())}
                        nothingFoundMessage="No se encontraron tecnicos"
                        size="xs"
                        onChange={(valores) => {
                            manejarCambioFiltroAgenda('Tecnicos', listaTecnicos.filter(t =>
                                valores.some(v => Number(v) === t.Id)
                            ))
                        }}
                        leftSection={<IconCalendarUser size={17} />}
                        // data={['Juan Perez', 'Laura Rendon', 'Juan Rodriguez', 'Jose Sanchez']}
                        searchable
                    />
                </Grid.Col>
                <Grid.Col
                    style={{ display: 'flex', justifyContent: 'center' }} span={{ base: 12, md: 12 }}>
                    <DatePicker
                        size="xs"
                        variant="light"
                        onChange={(value) => {
                            
                            const fechaNormalizada = value ? dayjs(value).startOf('day').toDate() : new Date();
                            manejarCambioFiltroAgenda('Fecha', fechaNormalizada);
                        }}
                        value={dayjs(filtro.Fecha).toDate()}
                        locale="es"
                    />
                </Grid.Col>

            </Grid>
        </Box>
    )
}

export default FiltrosAgendaVista;